

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";
import { InvoicePayment } from './invoicePayment.model';

export class SearchPayment {



payment_id?: number;
payment_date?: string;
myob_account_code_id?: number;
myob_bank_account_code_id?: number;
from_brand_id?: number; // who the payments will be appled to. (who the payment is from)
to_brand_id?: number; // who the payments will be appled to. (who the payment is from)
payment_total?: number;
created_by?: number;
created_date?: any;
updated_by?: number;
updated_date?: any;

invoicePayment?: InvoicePayment; // class
from_brand_name?: string;
to_brand_name?: string;

job_number?: string;
subject_number?: string;
is_bulk?: number;

// myob variables.
UID?;
DepositTo?;
AccountUID?;
CustomerUID?;
URI?;
myob_array?: any;
RowVersion?;
myob_id?;

invoice_id?: number;
invoiceUID?: any;

agent_id?: number;

invoice_payment_id?: number;
// invoice_id: number;
// payment_id: number;
payment_amount?: number;
invoice_number?: string;
subject_id?: number;
// subject_number: string;
job_id?: number;
// job_number: string;
// payment_date: string;
// myob_account_code_id?: number;
// myob_bank_account_code_id?: number;
// from_brand_id?: number; // who the payments will be appled to. (who the payment is from)
// to_brand_id?: number; // who the payments will be appled to. (who the payment is from)
// payment_total?: number;
remaining_total?: number;
invoice_total?: number;
// created_by?: number;
// created_date?: string;
// updated_by?: number;
// updated_date?: string;

created_date_from?;
created_date_to?: string;
access_level?: number;
brand_type_id?: number;

job_type_id?: number;
file_id?: number;
date_created?: string;
invoice_gst?: number;
invoice_status_id?;
invoice_payment_status_id?;
invoice_communication_status_id?;

due_date?: string;
invoice_subtotal?: number;
invoice_payment_total?: number;
invoice_remaining_total?: number;
is_job_invoice?: number; // 1 if so.


work_order_status_id?: number;
work_order_payment_status_id?: number;
work_order_communication_status_id?: number;


sync_with_myob?;
myob_sync_status?;


// UID?;
Number?;
Date?;
CustomerPurchaseOrderNumber?;
// CustomerUID?;
CustomerName?;
CustomerDisplayID?;
PromisedDate?;
BalanceDueAmount?;
BalanceDueAmountForeign?;
Status?;
TermsPaymentIsDue?;
TermsDiscountDate?;
TermsBalanceDueDate?;
TermsDiscountForEarlyPayment?;
TermsMonthlyChargeForLatePayment?;
TermsDiscountExpiryDate?;
TermsDiscount?;
TermsDueDate?;
TermsFinanceCharge?;
IsTaxInclusive?;
Subtotal?;
SubtotalForeign?;
Freight?;
FreightForeign?;
FreightTaxCodeUID?;
TotalTax?;
TotalTaxForeign?;
TotalAmount?;
TotalAmountForeign?;
CategoryUID?;
SalespersonUID?;
Comment?;
ShippingMethod?;
JournalMemo?;
ReferralSource?;
InvoiceDeliveryStatus?;
LastPaymentDate?;
CanApplySurcharge?;
OrderUID?;
OnlinePaymentMethod?;
ForeignCurrency?;
CurrencyExchangeRate?;
LastModified?;
// URI?;
// RowVersion?;

/*

subject_id?: number;
    job_id?: number;
    first_name?: string;
    surname?: string;
    title?: string;
    is_active?: string;
    next_date?: string;
    final_date?: string;
    job_status_id?: number;
    street_address?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
    phone_h?: string;
    email?: string;
    dob?: string;
    phone_m?: string;
    subject_type_id?: number;
    file_number?: string;
    special_instructions?: string;
    job_status?: string;
    reference_number?: string;
    job_reference_number?: string;
    subject_number?: string;
    created_by?: number;
    created_date?: string;
    updated_date?: string;
    updated_by?: number;
    completed_date?: string;
    completed_by?: string;
    start_date?: string;
    started_by?: string;
    time_taken?: string;
    sex?: string;
    finalised?: string;
    subject_reference_created?: string;
    brand_report_user_id?: number;
    job_type_id?: number;
    job_type_location_id?: number;
    job_type_court_id?: number;
    job_type_document_type_id?: number;
    job_type_affidavit_type_id?: number;
    business_name?: string;
    prev_subject_id?: number;
    next_subject_id?: number;


    number_subjects?: number;
    existing_subjects_count?: number;

    job_subject_type_id?: number;
    subject_report_order_number?: number;

    job_service_rule_id?: number;
    job_service_timeframe_id?: number;
    subject_service_type_id: number;

    service_company_name?: string;
service_directors_name?: string;
service_prison_name?: string;
service_law_firm_name?: string;
 service_solicitor_name?: string;


//  public job_id: number;
  public job_number?: string;
  // public file_number?: number;
  public brand_id: number;
  // public job_type_id: number;
  public client_company_name?: string;
  public client_name?: string;
  public client_phone?: string;
  // public special_instructions?: any;
  public report_type_id: number;
  public client_client_id?: number;
  // public updated_by?: number;
  // public created_date?: string;
  public creatded_by?: number;
  // public created_by?: number;
  public owner_trace_code?: string;
  // public updated_date?: number;
        // Advanced Fields // Dev Tools
        public project_type: number;
        public allocated_date: string;
        public allocated_to: number;
        public allocated_by: number;
        public status: number;
        public progress_percentage: number;
        public locate_status: number;
        public total_candidates_count: number;
        public completed_candidates_count: number;
        // public completed_date: string;
        public trace_api_key: string;

// additional fields for statistics and trackings upgrade
public pl_count: number;
public l_count: number;
public nl_count: number;
public fee: number;
public adverage_trace_time: number;
public total_open: number;
public total_all: number;
public total_all_all: number;
public pl_percent: number;
public l_percent: number;
public nl_percent: number;
// public completed_by?: number;
// public start_date: string;
// public started_by: number;
// public time_taken: number;
 
public client_invoice_id: number;
public client_id: number;
// public special_instructions: string;
// public job_type_location_id: number;
// public job_type_court_id: number;
// public job_type_document_type_id: number;
// public job_type_affidavit_type_id: number;
public client_contact_id: number;


public hearing_date: string;
public judgement_date: string;
public filing_date: string;
// public number_subjects: string;
public instructions_date: string;
public brand_invoice_id: number;
public brand_report_id: number;

job_status_code?: string;
document_page_count?: number;
document_invoice_printing?: string;
// job_service_rule_id?: number;
// job_service_timeframe_id?: number;

created_date_from: string;
created_date_to: string;


*/

  // ? what does this really do? (no encoding or deserialisation required...)
/*   deserialize(input: any): JobSubject {
    Object.assign(this, input);

    return this;
  } */



  // deserialize(input: any): SearchPayment {
  //   Object.assign(this, input);
  //   this.invoicePayment = new InvoicePayment().deserialize(input.invoicePayment);
  //   return this;
  // }
}

  // Set the Stats




  /*



CREATE TABLE subjects (
  subject_id int(11) NOT NULL AUTO_INCREMENT,
  job_id int(11) DEFAULT NULL,
  first_name varchar(255) DEFAULT NULL,
  surname varchar(255) DEFAULT NULL,
  title varchar(255) DEFAULT NULL,
  is_active varchar(255) DEFAULT NULL,
  next_date varchar(255) DEFAULT NULL,
  final_date varchar(255) DEFAULT NULL,
  job_status_id int(11) DEFAULT NULL,
  street_address varchar(255) DEFAULT NULL,
  suburb varchar(255) DEFAULT NULL,
  state varchar(255) DEFAULT NULL,
  postcode int(11) DEFAULT NULL,
  phone_h varchar(255) DEFAULT NULL,
  email varchar(255) DEFAULT NULL,
  dob varchar(255) DEFAULT NULL,
  phone_m varchar(255) DEFAULT NULL,
  subject_type_id int(11) DEFAULT NULL,
  file_number varchar(255) DEFAULT '1',
  special_instructions text,
  job_status varchar(255) DEFAULT 'OPEN',
  reference_number int(11) DEFAULT NULL,
  job_reference_number int(11) DEFAULT NULL,
  subject_number varchar(255) DEFAULT NULL,
  created_by int(11) DEFAULT NULL,
  created_date int(11) DEFAULT NULL,
  updated_date varchar(255) DEFAULT NULL,
  updated_by int(11) DEFAULT NULL,
  completed_date varchar(255) DEFAULT NULL,
  completed_by int(11) DEFAULT NULL,
  start_date varchar(11) DEFAULT NULL,
  started_by int(11) DEFAULT NULL,
  time_taken int(11) DEFAULT NULL,
  sex varchar(11) DEFAULT NULL,
  finalised int(11) NOT NULL DEFAULT '0',
  subject_reference_created int(11) DEFAULT '0',
  brand_report_user_id int(11) DEFAULT NULL,
  job_type_id int(11) DEFAULT NULL,
  job_type_location_id int(11) DEFAULT NULL,
  job_type_court_id int(11) DEFAULT NULL,
  job_type_document_type_id int(11) DEFAULT NULL,
  job_type_affidavit_type_id int(11) DEFAULT NULL,
  business_name varchar(255) DEFAULT NULL,
  prev_subject_id int(11) DEFAULT '0',
  next_subject_id int(11) DEFAULT '0',
  PRIMARY KEY (subject_id),
  KEY FK_subjects (job_id),
  CONSTRAINT FK_subjects FOREIGN KEY (job_id) REFERENCES jobs (job_id)
) ENGINE=InnoDB AUTO_INCREMENT=303 DEFAULT CHARSET=utf8

  
*/